/* RESPONSIBLE TEAM: team-proactive-support */
import ConnectorConfiguration from './connector-configuration';

export default class NotOnlineConnectorConfiguration extends ConnectorConfiguration {
  node = undefined;

  get label() {
    if (this.node.isDelayable) {
      return `IF NOT ONLINE AFTER ${this.node.delayDescription}`;
    } else {
      return `IF NOT ONLINE AFTER 30D`;
    }
  }

  constructor(inputs) {
    inputs.component = 'series/node/connectors/standard-connector';
    super({ ...inputs });

    this.node = inputs.node;
  }
}
